import React, { useState, useEffect } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import deleteBin from '../../assets/icons/delete.svg';
import edit from '../../assets/icons/edit.svg';
import styles from './manager.module.css';
import SearchBar from '../../components/SearchBar';
import PrevAndNextBtn from '../../components/PrevAndNextBtn';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { useNavigate } from "react-router-dom";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';

function ManageTable({ list, handleEdit, handleDelete, loading }) {
    return (
        <TableContainer component={Paper} elevation={0}>
            <Table aria-label="hospital table">
                <TableHead>
                    <TableRow sx={{ background: '#c8ebea' }}>
                        <TableCell 
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '85%', paddingLeft: '2.5pc' }}
                        >
                            ชื่อโรงพยาบาล
                        </TableCell> 
                        <TableCell 
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '15%' }} 
                            align="center"
                        >
                            จัดการ
                        </TableCell> 
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.length === 0 ? (
                        <TableRow>
                            <TableCell 
                                className={styles.head2Text} 
                                colSpan={2} 
                                align="center" 
                                style={{ borderBottom: '1px solid transparent', paddingTop: '5pc' }}
                            >
                                {loading ? 'กำลังโหลดข้อมูล...' : 'ไม่มีข้อมูล'}
                            </TableCell>
                        </TableRow>
                    ) : (
                        list.map((each) => (
                            <TableRow key={each.hospital_code} sx={{ borderBottom: '1px solid transparent','&:hover': { backgroundColor: '#fafafa'}}}> 
                                <TableCell 
                                    className={styles.bodyText} 
                                    style={{ borderBottom: '1px solid transparent', padding: '10px 8px 10px 40px' }}
                                >
                                    {each.hospital_name}
                                </TableCell> 
                                <TableCell 
                                    style={{ borderBottom: '1px solid transparent', padding: '10px 8px' }} 
                                    align="center"
                                >
                                    <img 
                                        src={edit} 
                                        alt="Edit" 
                                        onClick={() => handleEdit(each.hospital_code, each.hospital_name)}  
                                        className={styles.modifyIcon} 
                                    />
                                    <img 
                                        src={deleteBin} 
                                        alt="Delete" 
                                        onClick={() => handleDelete(each.hospital_code, each.hospital_name)} 
                                        className={styles.modifyIcon} 
                                    /> 
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function HospitalManager() {   
    const [loading, setLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredList, setFilteredList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toDelete, setToDelete] = useState({ hospital_code: null, hospital_name: null }); // State for the item to delete
    const [showDeleteModal, setShowDeleteModal] = useState(false); // State for modal visibility
    const navigate = useNavigate();

    useEffect(() => {
        fetchHospitalData(currentPage,null,null);
    }, []);

    const fetchHospitalData = async (page,search) => {
        setLoading(true);
        const res = await api.findHospital(page,search,null);
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                setFilteredList(detail);
                setTotalPage(res['data']['pagging']['totalPage'])
            } else if ("Not found data." === res['data']['message']) {
                setFilteredList([]);
                setTotalPage(1);
            } else {
                //alert(res['data']['message']);
            }
        } else {
          alert("ไม่ตอบสนอง");
        }
    };

    const handleSearch = () => {
        setCurrentPage(1); 
        fetchHospitalData(1,searchQuery)
    };

    const handleEdit = (hospital_code, hospital_name) => {
        navigate('/hospitalEdit', { state: { hospital_code, hospital_name } });
    };

    const handleAdd = () => {
        navigate('/hospitalAdd');
    };

    const handleDeleteClick = (hospital_code, hospital_name) => {
        setToDelete({ hospital_code, hospital_name });
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        setLoading(true);
        const res = await api.deleteHospital(toDelete.hospital_code);
        setLoading(false);
        setShowDeleteModal(false);
        if (res) {
            if (res['data']['code'] === 200) {
                if (
                    filteredList.length === 1 &&
                    currentPage === totalPage &&
                    currentPage > 1
                ) {
                    setCurrentPage(currentPage - 1);
                    await fetchHospitalData(currentPage - 1, searchQuery);
                } else {
                    await fetchHospitalData(currentPage, searchQuery);
                }
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    };

    const handleCloseModal = () => {
        setShowDeleteModal(false);
    };

    const handleNext = async () => {
        if (currentPage < totalPage) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            await fetchHospitalData(nextPage,searchQuery);
        }
    };    

    const handlePrevious = async () => {
        if (currentPage > 1) {
            const previousPage = currentPage - 1;
            setCurrentPage(previousPage);
            await fetchHospitalData(previousPage,searchQuery);
        }
    };    

    return (
        <>
            <Loader loading={loading} />
            {showDeleteModal && (
                <CustomizedModal
                    onClose={handleCloseModal}
                    apiCall={confirmDelete}
                    confirmMessage={`ต้องการลบ "${toDelete.hospital_name}" หรือไม่?`}
                    confirmButtonText={`ยืนยัน`}
                />
            )}
            <Box className={styles.head1Text}>จัดโรงพยาบาล</Box>
            <Box className={styles.bodyText}>จัดการโรงพยาบาลเพื่อใช้ในการนำเข้าข้อมูลสุขภาพ</Box>
            <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box className={styles.head2Text}>ค้นหาโรงพยาบาล</Box>
                <SearchBar 
                    label="ค้นหาด้วยชื่อ" 
                    searchQuery={searchQuery} 
                    setSearchQuery={setSearchQuery} 
                    handleSearch={handleSearch} 
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 1 , marginRight: 1}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAdd}
                        sx={{ padding: 1, borderRadius: 1.5 }}
                    >
                        <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 35px' }}>เพิ่มใหม่</p>
                    </Button>
                </Box>
                <Box sx={{  marginTop: 2, flexGrow: 1, border: '1px solid #aeb4dd', borderRadius: 1, backgroundColor: 'white',position: 'relative',overflow: 'auto' }}>
                    <ManageTable 
                        list={filteredList} 
                        handleEdit={handleEdit} 
                        handleDelete={handleDeleteClick}  
                        loading={loading}
                    />   
                    <Box sx={{ marginRight: 2, marginBottom: 2}}>
                        <PrevAndNextBtn
                            handlePrevious={handlePrevious}
                            handleNext={handleNext}
                            currentPage={currentPage}
                            totalPage={totalPage}
                        />
                    </Box>
                </Box>   
            </Box>
        </>
    );
}
export default HospitalManager;
